import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1 t-left" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Customer Service")
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "mx-16 c-tip" }, "|", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Get more on XTrend Speed App ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_router_link = _resolveComponent("router-link")
  const _component_OnlyApp = _resolveComponent("OnlyApp")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Pic, {
        src: "logo_&_text",
        class: "pointer",
        width: "145",
        hegiht: "35",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goSpeed('', true)))
      })
    ]),
    _createVNode(_component_Pic, {
      src: "head_phone",
      hegiht: "16",
      width: "16"
    }),
    _createVNode(_component_router_link, { to: "/customerService" }, {
      default: _withCtx(() => [
        _createVNode(_component_t, {
          path: "me_5",
          class: "ml-4 c-title"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_OnlyApp, {
      tag: "button",
      class: "btn line sm primary",
      onClick: _ctx.get
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Pic, {
          src: "get_app",
          hegiht: "16",
          width: "16",
          class: "v-middle"
        }),
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}